exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.vendors-table{height:75vh;font-size:9pt}.vendors-table .vendors-table-style-actions{min-width:120px}.vendors-table .vendors-table-style-actions .actions-icons{text-align:center;white-space:nowrap}.vendors-table .vendors-table-style-phone{min-width:105px}.vendors-table .vendors-table-style-th-datetime{min-width:110px}.vendors-table .vendors-table-style-td-datetime{text-align:center}", ""]);

// exports
